import { useState, useCallback, useRef } from 'react';

export default function useScreenShareToggle(room, onError) {
  const [isSharing, setIsSharing] = useState(false);
  const stopScreenShareRef = useRef(null);

  const shareScreen = useCallback(() => {
    navigator.mediaDevices
      .getDisplayMedia({
        audio: false,
        video: {
          frameRate: 10,
          height: 1080,
          width: 1920,
        },
      })
      .then((stream) => {
        if (
          Array.from(room.participants.values())
            .concat(room.localParticipant)
            .some((participant) => Array.from(participant.tracks.values()).find((track) => track.trackName.includes('screen')))
        ) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        const track = stream.getTracks()[0];
        room?.localParticipant
          .publishTrack(track, {
            name: 'screen',
          })
          .then((trackPublication) => {
            stopScreenShareRef.current = () => {
              room.localParticipant.unpublishTrack(track);
              // TODO: remove this if the SDK is updated to emit this event
              room.localParticipant.emit('trackUnpublished', trackPublication);
              track.stop();
              setIsSharing(false);
            };

            track.onended = stopScreenShareRef.current;
            setIsSharing(true);
          })
          .catch(onError);
      })
      .catch((error) => {
        if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') {
          onError(error);
        }
      });
  }, [room, onError]);

  const toggleScreenShare = useCallback(() => {
    if (room) {
      // eslint-disable-next-line no-unused-expressions
      !isSharing ? shareScreen() : stopScreenShareRef.current();
    }
  }, [isSharing, shareScreen, room]);

  return [isSharing, toggleScreenShare];
}

/*
const [screenTrack, setScreenTrack] = useState(null);
const [shareScreenStream, setShareScreenStream] = useState(null);
const [shareScreen, setShareScreen] = useState(false);


const setShareScreenCb = useCallback(async () => {
  if (room) {
    if (!shareScreen && !screenTrack) {
      navigator.mediaDevices.getDisplayMedia().then(async (stream) => {
        const screenTrackLocal = stream.getVideoTracks()[0];
        setScreenTrack(screenTrackLocal);
        setShareScreenStream(stream);
        setShareScreen(true);
        await room.localParticipant.publishTrack(screenTrackLocal, { name: 'screen' });
        onParticipantStatusChange(room.localParticipant.identity, 'screen', true);
        screenTrackLocal.onended = () => {};
      });
    } else if (screenTrack) {
      await room.localParticipant.unpublishTrack(screenTrack);
      shareScreenStream.getVideoTracks()[0].stop();
      onParticipantStatusChange(room.localParticipant.identity, 'screen', false);
      setScreenTrack(null);
      setShareScreen(false);
    }
  }
}, [room, shareScreen, screenTrack]);
*/
